import { closePopupHelper, openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

export const openAiPhotoGenerationCancelGenerationModal = () =>
    openPopupHelper({
        popupName: popupNames.AI_GENERATION_CANCEL_MODAL,
    });

export const closeAiPhotoGenerationCancelGenerationModal = () => closePopupHelper(popupNames.AI_GENERATION_CANCEL_MODAL);
